import { IRestApiProps, useRestApi } from './use-rest-api.hook';
import { useAppConfigContext, useAuthServiceContext } from '@vivli/core/infrastructure/context';

export const useAuthRestApi = (props?: IRestApiProps) => {
    const { getTokenSilent } = useAuthServiceContext();
    const config = useAppConfigContext();

    const endpoint = props?.endpoint || `${props?.useSecureApi ? config?.secureApiUri : config?.apiUri}api`;

    return useRestApi({ getTokenRefresh: getTokenSilent, ...props, endpoint });
};
